import React from "react";
import { Modal, ModalBody, ModalFooter, Button } from "reactstrap";
import { X } from "react-feather";

interface ILogoutConfirmationModalProps {
    isOpen: boolean;
    toggle: () => void;
    onConfirm: () => void;
}

const LogoutConfirmationModal: React.FC<ILogoutConfirmationModalProps> = ({
    isOpen,
    toggle,
    onConfirm
}) => {
    const handleConfirm = () => {
        onConfirm();
        toggle();
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle} centered>
            <ModalBody className="d-flex flex-column align-items-center justify-content-center" style={{ padding: "2rem", position: "relative" }}>
                <X
                    className="position-absolute"
                    style={{ top: "1rem", right: "1rem", cursor: "pointer" }}
                    onClick={toggle}
                    size={20}
                />
                <p className="text-center mb-4" style={{ fontSize: "1.125rem", fontWeight: 500, color: "#2c3e50", marginTop: "1rem" }}>
                    Are you sure you want to log out?
                </p>
            </ModalBody>
            <ModalFooter className="d-flex justify-content-center" style={{ borderTop: "1px solid #dee2e6" }}>
                <Button
                    color="secondary"
                    onClick={toggle}
                    style={{
                        marginRight: "1rem",
                        minWidth: "100px",
                        padding: "0.5rem 1.5rem"
                    }}
                >
                    Cancel
                </Button>
                <Button
                    color="primary"
                    onClick={handleConfirm}
                    style={{
                        minWidth: "100px",
                        padding: "0.5rem 1.5rem"
                    }}
                >
                    Yes, Logout
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default LogoutConfirmationModal;

